import * as React from "react";
import { Flex, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import logoText from "./logoText.png";

export const Navbar = () => {
  const navigate = useNavigate();
  return (
    <Flex
      position="fixed"
      zIndex="1000"
      top="40px"
      left="40px"
      onClick={() => {
        navigate("/");
      }}
    >
      <Image src={logoText} w="200px" />
    </Flex>
  );
};
